import React, { useState, useRef } from 'react';
import { FilterPod, TableComponents, ConfirmDialog, ButtonLoading, Icons } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { makeStyles } from '@mui/styles';
import createToast from 'components/Toast/Toast';
import { Grid, Menu, MenuItem, IconButton, Box } from '@mui/material';
import copy from 'copy-to-clipboard';
import jMoment from 'moment-jalaali';
import { SelectClientDialog } from '../components';
import { ExportButton } from 'components';
import { useExportFile } from 'hooks';
import InitFilters from './constants/InitFiltering';
import Services from './services/AllReceivedRequestsServices';
import { columns, generateData } from './components/Columns';
import { enifyNumber, numberTester, enifyDateTime } from '../../../utility';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import FilterButton from 'components/FilterPod/FilterButton';
import {
  getExportReceivedRequestsUrl,
} from 'URLs';
jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const AssignedDelegation = () => {
  // -- STATES --//
  const [loading, setLoading] = useState(false);
  const [confirmingRow, setConfirmingRow] = useState(false);
  const [cancelingRequest, setCancelingRequest] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const [isConfirmWithoutClientIdOpen, setIsConfirmWithoutClientIdOpen] = useState(false);
  const [selectedRowToConfirm, setSelectedRowToConfirm] = useState(null);
  const [page, setPage] = useState(0);
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const actionsList =
    getDynamicObjectAction([
      'exportRequestSetServiceDefinePage'

    ])
  // It should be declared here cause of hirearchy!
  const getAccounts = async (val) => {
    if (val?.length >= 2) {
      try {
        const q = {
          size: 10,
          offset: 0,
        };

        const enifiedValue = enifyNumber(val);
        q[numberTester.test(enifiedValue) ? 'businessId' : 'query'] = enifiedValue;

        const result = await Services.getBusinessList(q);
        const data = result.result;
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val.name} (شناسه: ${val?.id})`,
          value: val.id,
        }));
        return list;
      } catch (e) {
        return [];
      }
    }
  };
  const [filters, setFilters] = useState(InitFilters(getAccounts));
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef();
  const { downloadFile, isExporting } = useExportFile({
    url: getExportReceivedRequestsUrl(),
    filename: 'received-requests-list',
  });

  // --API REQUESTS--//
  const getRequestsData = async (query) => {
    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      jMoment.loadPersian({ usePersianDigits: false });
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        fromDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        toDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getRequests(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const confirmRequest = async (rowData) => {
    let correctRowData = {};

    if (rowData?.scClientId?.client_id && selectedRowToConfirm) {
      // incoming from confirm client id selection dialog
      correctRowData = {
        ...selectedRowToConfirm,
        clientId: rowData?.scClientId?.client_id,
      };
    } else if (!rowData || !rowData?.clientId) {
      // if incoming row has not client id
      setSelectedRowToConfirm(rowData);
      setIsConfirmWithoutClientIdOpen(true);
      return;
    } else {
      // if incoming row has client id by itself
      correctRowData = { ...rowData };
    }

    const data = {
      id: correctRowData.id,
      clientId: correctRowData.clientId,
      productId: correctRowData.product?.id,
      srcBusinessId: correctRowData.srcBusiness?.id,
    };

    let txt = '';
    let hasErr = false;

    try {
      setConfirmingRow(true);
      await Services.confirmRequestApi(data);
      txt = 'با موفقیت تایید شد.';
      handleCloseDialog();
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (e) {
      txt = 'خطا در سرویس';
      hasErr = true;
      if (e.response && (e.response?.data.status === 500 || e.response?.data.status === 403)) {
        txt = e.response.data.message;
      }
    } finally {
      setConfirmingRow(false);
    }
    createToast(hasErr ? 'خطا' : 'موفق', txt, hasErr ? 'danger' : 'success');
  };

  const deleteService = async () => {
    if (!selectedRowToDelete) return;
    try {
      setCancelingRequest(true);
      const params = {
        productId: selectedRowToDelete.product?.id,
      };
      await Services.revokeApiKeyApi(params, selectedRowToDelete.id);
      createToast('موفق', 'درخواست با موفقیت لغو شد!', 'success');

      handleCloseDialog();
      setCancelingRequest(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (e) {
      setCancelingRequest(false);
    }
  };

  const onDeleteReq = (rowData) => {
    setSelectedRowToDelete(rowData ?? null);
    setIsConfirmOpen(!!rowData);
  };

  const handleCloseDialog = () => {
    setSelectedRowToDelete(null);
    setSelectedRowToConfirm(null);

    setIsConfirmOpen(false);
    setIsConfirmWithoutClientIdOpen(false);
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    const obj = {
      ...filterParams.params,
      startDate: filterParams?.params?.fromDate,
      endDate: filterParams?.params?.toDate,
    };
    delete obj['fromDate'];
    delete obj['toDate'];
    delete obj['offset'];
    downloadFile(types[index], filterParams?.data, obj);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const copyItem = (item, title = 'متن مورد نظر') => {
    if (!item) return;
    try {
      copy(item);
      createToast('موفق', `${title} با موفقیت کپی شد!`, 'success');
    } catch (error) { }
  };

  // -- LOCAL VARIABLES--//
  return (
    <div className={classes.root}>
      <SelectClientDialog
        open={isConfirmWithoutClientIdOpen}
        closeDialogForm={handleCloseDialog}
        confirm={confirmRequest}
        loading={confirmingRow}
      />
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          {actionsList['exportRequestSetServiceDefinePage'] && (
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      <TableComponents
        data={getRequestsData}
        columns={columns(confirmRequest, onDeleteReq, copyItem)}
        isLoading={loading}
        ref={tableRef}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getRequestsData(ps)
        }}
      />
      {/* Confirm Delete Request */}
      <ConfirmDialog
        open={isConfirmOpen}
        onClose={handleCloseDialog}
        loading={cancelingRequest}
        onConfirm={deleteService}
        title="تایید لغو درخواست"
        content={`آیا از لغو درخواست سرویس ${selectedRowToDelete?.product?.name
          ? `"${selectedRowToDelete?.product?.name}"`
          : 'مورد نظر'
          } اطمینان دارید؟`}
        confirmButtonText="بله، لغو درخواست"
        cancelButtonProps="انصراف"
      />
    </div>
  );
};

// See detail for every row

export const TableItemActions = ({ otherMenus, startIcon, title, iconButton = false }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  // --HOOKS--//
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // --API--//

  return (
    <div className={classes.otherActions}>
      {iconButton ? (
        <IconButton onClick={handleClick} size="large">
          <Icons icon="MoreHorizontal" color="#667585" size="20" />
        </IconButton>
      ) : (
        <ButtonLoading
          variant="outlined"
          onClick={handleClick}
          color="primary"
          startIcon={startIcon ?? null}
          name={title ?? 'عملیات'}
          aria-controls="simple-menu"
          aria-haspopup="true"
        />
      )}

      <Menu
        id="simple-menu"
        className={classes.otherActionsMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {otherMenus.map((v, k) => (
          <MenuItem
            className={classes.otherActionsMenuItem}
            key={k}
            disabled={v?.disabled}
            onClick={(e) => {
              e.preventDefault();
              if (v?.disabled) return;
              v?.onClick?.();
              handleClose();
            }}
          >
            {v?.title}
          </MenuItem>
        ))}
        {/* <MenuItem onClick={() => handleClose()}>بستن</MenuItem> */}
      </Menu>
    </div>
  );
};
const darkGray = '#263238';
const useStyles = makeStyles((theme) => ({
  root: {

    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
    '& .MuiIconButton-root': {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
    justifyContent: 'center',
    '& .MuiIconButton-root': {
      border: '2px solid #303d8f',
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      '& svg': {
        fill: '#303d8f',
        transform: 'scale(0.8)'
      }
    }
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
    '& .MuiButtonBase-root.Mui-disabled': {
      pointerEvents: 'auto !important',
    },
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: darkGray,
    fontSize: 13,
    minWidth: 160,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  generatedApiKey: {
    background: theme.palette.grey[200],
    padding: theme.spacing(1, 2),
    paddingInlineStart: theme.spacing(1),
    borderRadius: 4,
    textAlign: 'center',
    fontSize: 15,
    marginTop: theme.spacing(2),
    '& b': {
      fontFamily: 'Vazir',
    },
  },
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));

export default AssignedDelegation;
